import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { cn } from "$lib/utils.js";

var root_1 = $.from_html(`<input/>`);
var root_2 = $.from_html(`<input/>`);

export default function Input($$anchor, $$props) {
	$.push($$props, true);

	let ref = $.prop($$props, 'ref', 15, null),
		value = $.prop($$props, 'value', 15),
		files = $.prop($$props, 'files', 15),
		dataSlot = $.prop($$props, 'data-slot', 3, "input"),
		restProps = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'ref',
			'value',
			'type',
			'files',
			'class',
			'data-slot',
			'onfocus'
		]);

	function handleFocus(event) {
		if ($$props.type === 'number' && ref()) {
			setTimeout(() => ref()?.select(), 0);
		}

		$$props.onfocus?.(event);
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var input = root_1();

			$.attribute_effect(
				input,
				($0) => ({
					'data-slot': dataSlot(),
					class: $0,
					type: 'file',
					...restProps
				}),
				[
					() => cn("selection:bg-primary dark:bg-input/30 selection:text-primary-foreground border-input ring-offset-background placeholder:text-muted-foreground flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 pt-1.5 text-sm font-medium shadow-xs transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]", "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", $$props.class)
				],
				void 0,
				void 0,
				void 0,
				true
			);

			$.bind_this(input, ($$value) => ref($$value), () => ref());
			$.bind_files(input, files);
			$.bind_value(input, value);
			$.append($$anchor, input);
		};

		var alternate = ($$anchor) => {
			var input_1 = root_2();

			$.attribute_effect(
				input_1,
				($0) => ({
					'data-slot': dataSlot(),
					class: $0,
					type: $$props.type,
					...restProps,
					onfocus: handleFocus
				}),
				[
					() => cn("border-input bg-background selection:bg-primary dark:bg-input/30 selection:text-primary-foreground ring-offset-background placeholder:text-muted-foreground flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]", "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", $$props.class)
				],
				void 0,
				void 0,
				void 0,
				true
			);

			$.bind_this(input_1, ($$value) => ref($$value), () => ref());
			$.bind_value(input_1, value);
			$.append($$anchor, input_1);
		};

		$.if(node, ($$render) => {
			if ($$props.type === "file") $$render(consequent); else $$render(alternate, false);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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